import { render, staticRenderFns } from "./EditBannerSectorComponent.vue?vue&type=template&id=8108b1fc&scoped=true"
import script from "./EditBannerSectorComponent.vue?vue&type=script&lang=js"
export * from "./EditBannerSectorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8108b1fc",
  null
  
)

export default component.exports